import type { Dayjs } from 'dayjs';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import weekOfYear from 'dayjs/plugin/weekOfYear';
import dayjs from 'dayjs';

dayjs.extend(weekOfYear);
dayjs.extend(customParseFormat);

export type Week = [Dayjs, Dayjs];

export const getDateWeek = (date: Dayjs): Week => {
  return [date.day(1), date.day(5)];
};

export const getCurrentWeek = (): Week => {
  return getDateWeek(dayjs());
};

export const getWeekByOffset = (week: Week, offset: number): Week => {
  return [week[0].day(1 + offset * 7), week[0].day(5 + offset * 7)];
};

export const getDatesBetweenTwoDates = (
  start: Dayjs,
  end: Dayjs,
): Array<Dayjs> => {
  let current = start;
  const result: Array<Dayjs> = [];

  while (!current.isAfter(end)) {
    result.push(current);
    current = current.add(1, 'day');
  }
  return result;
};

export const getCurrentDate = (format?: string): string => {
  const dateFormat = format ?? 'YYYY-MM-DD HH:mm:ss';
  return dayjs().format(dateFormat);
};

export const getRepeatedDates = (
  fromDate: Dayjs,
  toDate: Dayjs,
  weekdays: number[],
): Dayjs[] => {
  const dates = getDatesBetweenTwoDates(fromDate, toDate);
  const filteredDates: Dayjs[] = [];
  for (let i = 0; i < dates.length; i += 1) {
    const value = weekdays.find((val) => {
      const day = dates[i].day() === 0 ? 6 : dates[i].day() - 1;
      return !!(val === day);
    });
    if (value !== undefined) filteredDates.push(dates[i]);
  }
  return filteredDates;
};
